import React from 'react';
import {Pressable} from 'react-native';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {faCalendar} from '@fortawesome/free-regular-svg-icons/faCalendar';
import {faContactBook} from '@fortawesome/free-regular-svg-icons/faContactBook';
import {faEnvelope} from '@fortawesome/free-regular-svg-icons/faEnvelope';
import {faUser} from '@fortawesome/free-regular-svg-icons/faUser';
import {faBarcode} from '@fortawesome/free-solid-svg-icons/faBarcode';
import {faCircleXmark} from '@fortawesome/free-solid-svg-icons/faCircleXmark';
import {faDollarSign} from '@fortawesome/free-solid-svg-icons/faDollarSign';
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus';
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';

type IconProps = {
  disabled?: boolean;
};

const i =
  (icon: IconDefinition) =>
  ({disabled}: IconProps) =>
    (
      <FontAwesomeIcon
        icon={icon}
        style={{color: disabled ? '#919191' : undefined}}
      />
    );

type IconButtonProps = IconProps & {
  onPress: () => void;
};

const ib =
  (icon: IconDefinition) =>
  ({onPress, disabled}: IconButtonProps) =>
    <Pressable onPress={onPress}>{i(icon)({disabled})}</Pressable>;

export const CalendarIcon = i(faCalendar);
export const ContactBookIcon = i(faContactBook);
export const DollarSignIcon = i(faDollarSign);
export const EnvelopeIcon = i(faEnvelope);
export const PlusIcon = i(faPlus);
export const UserIcon = i(faUser);

export const BarcodeIconButton = ib(faBarcode);
export const CircleXMarkIconButton = ib(faCircleXmark);
export const SearchIconButton = ib(faSearch);
export const TrashIconButton = ib(faTrash);
